var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 333.33 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70.33,
    width: 448,
    height: 135,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "talk_banner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.57,222.78a67,67,0,0,1-36.52-36.07,66.94,66.94,0,0,1-.26-51.31,53.67,53.67,0,0,1,28.9-29.2A53.75,53.75,0,0,1,8.65,106a43,43,0,0,1,23.58,56,34.42,34.42,0,0,1-18.54,18.73,34.42,34.42,0,0,1-26.35.14,27.55,27.55,0,0,1-15-14.83,27.55,27.55,0,0,1-.12-21.1A22.14,22.14,0,0,1,1,132.8a17.74,17.74,0,0,1,9.72,23.09,14.24,14.24,0,0,1-7.65,7.73,14.24,14.24,0,0,1-10.88.06A11.4,11.4,0,0,1-14,148.83h0a9.18,9.18,0,0,1,12-5,7.39,7.39,0,0,1,4,9.61,6,6,0,0,1-7.74,3.25,4.78,4.78,0,0,1-2.62-6.23,3.86,3.86,0,0,1,5-2.12,3.12,3.12,0,0,1,1.71,4.07A2.55,2.55,0,0,1-5,153.77a2.07,2.07,0,0,1-1.13-2.7,1.69,1.69,0,0,1,2.2-.93A1.39,1.39,0,0,1-3.13,152a1.17,1.17,0,0,1-1.5.63,1,1,0,0,1-.53-1.25.81.81,0,0,1,1-.44.67.67,0,0,1,.37.88.58.58,0,0,1-.76.32.5.5,0,0,1-.27-.65.31.31,0,0,1,.1-.15.4.4,0,0,0-.14.18.58.58,0,0,0,.32.76.78.78,0,0,0,1-.43A1,1,0,0,0-4,150.49a1.32,1.32,0,0,0-1.72.72,1.7,1.7,0,0,0,.93,2.21A2.18,2.18,0,0,0-2,152.23a2.77,2.77,0,0,0-1.51-3.59,3.49,3.49,0,0,0-4.55,1.92,4.4,4.4,0,0,0,2.41,5.74h0a5.57,5.57,0,0,0,7.25-3.05,7,7,0,0,0-3.84-9.11A8.8,8.8,0,0,0-13.69,149a11,11,0,0,0,6,14.37h0a13.84,13.84,0,0,0,18-7.58,17.35,17.35,0,0,0-9.52-22.6,21.76,21.76,0,0,0-28.32,11.91,27.2,27.2,0,0,0,14.92,35.45,34.13,34.13,0,0,0,26.07-.15,34.09,34.09,0,0,0,18.33-18.52,42.62,42.62,0,0,0-.18-32.6A42.63,42.63,0,0,0,8.51,106.32,53.39,53.39,0,0,0-61,135.54a66.71,66.71,0,0,0,36.58,86.89A83.53,83.53,0,0,0,84.32,176.71l.35.15A83.78,83.78,0,0,1-24.57,222.78Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.43,108.78A67,67,0,0,1,327.65,21.4,53.72,53.72,0,0,1,397.65-8a43,43,0,0,1,23.58,56,34.44,34.44,0,0,1-44.89,18.87,27.56,27.56,0,0,1-15.13-35.93A22.14,22.14,0,0,1,390,18.8a17.74,17.74,0,0,1,9.72,23.09,14.22,14.22,0,0,1-18.53,7.79A11.4,11.4,0,0,1,375,34.83h0a9.18,9.18,0,0,1,12-5,7.38,7.38,0,0,1,4,9.6,5.94,5.94,0,0,1-7.74,3.26,4.79,4.79,0,0,1-2.62-6.24,3.86,3.86,0,0,1,5-2.11,3.12,3.12,0,0,1,1.71,4.07,2.55,2.55,0,0,1-3.31,1.4,2.07,2.07,0,0,1-1.13-2.7,1.69,1.69,0,0,1,2.2-.93,1.38,1.38,0,0,1,.77,1.81,1.17,1.17,0,0,1-1.5.64,1,1,0,0,1-.53-1.25.81.81,0,0,1,1.05-.44.67.67,0,0,1,.37.88.58.58,0,0,1-.76.32.5.5,0,0,1-.27-.65.31.31,0,0,1,.1-.15.4.4,0,0,0-.14.18.58.58,0,0,0,.32.76.78.78,0,0,0,1-.43,1,1,0,0,0-.56-1.32,1.32,1.32,0,0,0-1.72.72,1.7,1.7,0,0,0,.93,2.21A2.18,2.18,0,0,0,387,38.23a2.77,2.77,0,0,0-1.51-3.59,3.49,3.49,0,0,0-4.55,1.92,4.4,4.4,0,0,0,2.41,5.74h0a5.57,5.57,0,0,0,7.25-3,7,7,0,0,0-3.84-9.11A8.8,8.8,0,0,0,375.31,35a11,11,0,0,0,6,14.37h0a13.84,13.84,0,0,0,18-7.58,17.35,17.35,0,0,0-9.52-22.6,21.76,21.76,0,0,0-28.32,11.91,27.2,27.2,0,0,0,14.92,35.45,34.08,34.08,0,0,0,44.4-18.67A42.58,42.58,0,0,0,397.51-7.68,53.4,53.4,0,0,0,328,21.54a66.71,66.71,0,0,0,36.58,86.89A83.53,83.53,0,0,0,473.32,62.71l.35.15A83.9,83.9,0,0,1,397.12,115a83.26,83.26,0,0,1-32.69-6.21Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.66,94.23a1.44,1.44,0,0,1-1.45-1.43V57.14a1.45,1.45,0,0,1,1.45-1.43h34.77a1.44,1.44,0,0,1,1.45,1.43V92.8a1.43,1.43,0,0,1-1.45,1.43Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.43,62.94c-.55,0-1,.71-1,1.6s.45,1.61,1,1.61h20.43c.56,0,1-.72,1-1.61s-.45-1.6-1-1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.43,67.75c-.36,0-.69.31-.87.8a2.47,2.47,0,0,0,0,1.61c.18.5.51.8.87.8h20.43c.56,0,1-.72,1-1.6s-.45-1.61-1-1.61Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.25,86.21a6,6,0,1,1,6-6A6,6,0,0,1,113.25,86.21Z",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107,39a50.53,50.53,0,0,1,34.71,6,63.94,63.94,0,0,1,9.82,7.27c3.12,2.72,6.14,5.56,9.4,8.11a52.81,52.81,0,0,0,32.75,11.45c1,0,2,0,2.95-.08.53,0,.54-.86,0-.83a52,52,0,0,1-33.86-10.16c-3.37-2.51-6.45-5.38-9.6-8.16a75.17,75.17,0,0,0-9.65-7.48,51.23,51.23,0,0,0-55.64.86,4.08,4.08,0,0,1,.48.68A50.76,50.76,0,0,1,107,39Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.79,48.49a4,4,0,1,1,4,4,4,4,0,0,1-4-4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.08,105.46a4,4,0,1,1,4,4A4,4,0,0,1,241.08,105.46Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.65,79.79a1.44,1.44,0,0,1-1.45-1.44V42.71a1.45,1.45,0,0,1,1.45-1.44h69.23a1.44,1.44,0,0,1,1.45,1.44V78.35a1.45,1.45,0,0,1-1.45,1.44Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.81,54.51a6,6,0,1,1,6,6,6,6,0,0,1-6-6Z",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.62,49.29c-.35,0-.67.31-.84.81a2.57,2.57,0,0,0,0,1.6c.17.5.49.8.84.8h36.53c.54,0,1-.71,1-1.6s-.43-1.61-1-1.61Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.25,55.71c-.36,0-.69.31-.87.8a2.47,2.47,0,0,0,0,1.61c.18.5.51.8.87.8h20.43c.56,0,1-.72,1-1.6s-.45-1.61-1-1.61Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.15,64.54a1.63,1.63,0,0,0,0,3.21h54.22a1.63,1.63,0,0,0,0-3.21Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.15,71a1.63,1.63,0,0,0,0,3.21h54.22a1.63,1.63,0,0,0,0-3.21Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.58,110.93c2,.86,3.9,1.77,5.92,2.45a33.66,33.66,0,0,0,5.22,1.27,35.74,35.74,0,0,0,10.73.07,36.46,36.46,0,0,0,10.36-3.11,34.09,34.09,0,0,0,6.11-3.66,7,7,0,0,1-.44-.75,33.82,33.82,0,0,1-5,3.15,35.73,35.73,0,0,1-10.16,3.37,34.91,34.91,0,0,1-10.7.19,32.29,32.29,0,0,1-5.24-1.18,52.4,52.4,0,0,1-5.78-2.32c-3.84-1.7-8.11-3.36-12.32-2.19a10,10,0,0,0-1.42.52c-.5.23-.07,1,.43.75,4-1.8,8.54-.23,12.34,1.44Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.79,119.91H156.93l7.73-13.45a1.58,1.58,0,0,1,2.15-.58,1.47,1.47,0,0,1,.58.58l3.31,5.75,5.62-9.77a2,2,0,0,1,2.69-.72,1.87,1.87,0,0,1,.73.72Z",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.37,119.91a1.46,1.46,0,0,1-1.45-1.46V98.9a1.45,1.45,0,0,1,1.45-1.46h34.77a1.45,1.45,0,0,1,1.45,1.46v19.55a1.47,1.47,0,0,1-1.45,1.46Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,104.13l-6.28,3.09c-2.24,1.1-4.41.91-5.23-1.39a3.94,3.94,0,0,1,.32-3.35,4.19,4.19,0,0,1,2.84-1.94l6-1.08,25.57-8.22,15.49-10.65,5.68,8.77-17.9,9.36Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.45,190.59,326.63,193l-27.78-36.6-8.73,43-5.82-1.06c-3.73-37-6.78-74.83-3-92.7l21.56-.93,9.79,31.3,4.76,21.22Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,57.32A9.62,9.62,0,1,1,295.58,67,9.62,9.62,0,0,1,286,57.32Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,78.18l-12.79-2.72-1.63-10.62,9-1.9Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.34,105.46h-23l5.18-12.6c-.38-4.33,1.52-7.52,4.23-10.3l3.45-8.37c5.56-3.55,9.76-3.29,14.23,1.32C312.74,82.78,309.08,93.7,303.34,105.46Z",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.18,132.28l-.64,7.08c-.22,2.53-1.53,4.28-4,3.71a4.14,4.14,0,0,1-2.73-2.13,4.28,4.28,0,0,1-.19-3.5l2.22-5.7,6.37-26.4-1.06-19.13H302.8l-1.33,20.47Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,87h-12l.84-7.23a5.23,5.23,0,0,1,5.16-4.8,5.68,5.68,0,0,1,3.95,1.31,4.82,4.82,0,0,1,1.76,3.5Z",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,44.08a3.61,3.61,0,1,1,3.61,3.61h0A3.61,3.61,0,0,1,302.8,44.08Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.45,41.47A3.59,3.59,0,0,1,306,38.09l-.22,0a3.61,3.61,0,0,0-.45,7.21h.22a3.6,3.6,0,0,1-3.1-3.81Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.57,44.66c-3.08-2.66-11.92.72-12.49,2.51-4.16.59-7.32,3.11-7.32,7.6,2.48,1.06,5.3.93,8.34,0,4.85,4.11,5.19,9.28,2.24,15.21l3.63.08,4.5-6.84.21,6.94L310,70V60.05a21.44,21.44,0,0,0-2.13-9.52c-1.3-2.62-3.31-4.15-5.31-5.87Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,60.93a1.65,1.65,0,1,1,1.6,2,1.84,1.84,0,0,1-1.6-2Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.78,62.08s1-17.85,6.18-13.79S80.7,63.74,80.7,63.74Z",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.94,116.7s11.81,13.47,5.2,14.4-9.21-12.7-9.21-12.7Z",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.07,52.58a7.91,7.91,0,0,1,5.86,6.53l3.85,27.13,5.4,21.64s2.7,2.41,1.62,3.75,1.35,6.94,1.35,6.94l-6.75,2.14s-.81-5.61-2.16-5.88C49.06,114.6,35.78,79.49,32.59,71c-.45-1.17-.69-1.84-.69-1.84S32.43,51.24,41.07,52.58Z",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.28,111.49l4,46.56s.14,27.83,4.41,33.22,4.41,8.08,4.41,8.08L43.92,195s-4.54-7.27-3.61-8.38a6.17,6.17,0,0,0,1.2-2.4l-2.4-28.73,4.54-50Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3,110.79l2,43.88s-18.63,39.67-20.67,40.72a5.28,5.28,0,0,0-2.56,3.15l-11.23-2.89,5.11-8.4,11.23-28.12a4.61,4.61,0,0,0,2.3-3.41c.51-2.63,1.53-2.63-1-3.16a3.25,3.25,0,0,1-2.56-3.15l-8.42-39.93Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9,44.4a10.34,10.34,0,1,1,11.86-8.55A10.33,10.33,0,0,1,44.9,44.4Z",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.82,34.05S37,47,36,48.26s11.11,1,11.11,1-.8-10.91,0-11.92S37.82,34.05,37.82,34.05Z",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.94,115.09s-29.06-2.61-34.46,0c0,0,2-7.48,1.47-8.26-.37-.57.66-21.88.33-34.17C23.1,65.72,21.52,59,26.11,53.8a14.16,14.16,0,0,1,5.14-3.93s-.52-5,2.06-5.22c0,0,9.77-1,13.37,2.09,1.15,1,1.88,4,2,6.63-1.78,8.89-1.15,18.75.49,29,.1.65.21,1.3.32,2C51.17,94.44,53.79,104.9,55.94,115.09Z",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,37a13.79,13.79,0,0,1,2.61.37,6.63,6.63,0,0,0,7.07-5,3.51,3.51,0,0,1,.36-1.18,2.33,2.33,0,0,1,2.48-.76,19.41,19.41,0,0,0,2.68.66,4.11,4.11,0,0,0,3.54-2A6.82,6.82,0,0,0,59.91,25l-.68.72a3.51,3.51,0,0,1-.31-1.89,2.22,2.22,0,0,0-2.07.53c-.6.07-.14-1.11-.59-1.52a1.09,1.09,0,0,0-.73-.14c-1.27,0-2.31-1-3.31-1.75a14.23,14.23,0,0,0-6-2.73,7.81,7.81,0,0,0-4.34.22A9.05,9.05,0,0,0,39,20.5a17.91,17.91,0,0,0-4.93,7.33A12.3,12.3,0,0,0,34,35c.36,1.22,1.44,5.38,3,5.48,2,.12.8-3.35,3.28-3.5Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7,52.5l3.69.41s3.61,7.16,3.35,8.65-.83.59.79,3,6.25,8.57,6.82,9.48,16.17-11.24,15.2-14.88c0,0,4.93,3.61,7,4.09,0,0-16.08,21.51-18.31,24.26s-4.05,2.19-7.12.56S37.51,70.13,37.51,70.13Z",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.73,85.4l-12-13.34,3-1.1,8.68,12.43Q48.57,84.4,48.73,85.4Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkBanner);
export default __webpack_public_path__ + "static/media/talk_banner.c57fc214a8259a99339cb86f0a6e88e1.svg";
export { ForwardRef as ReactComponent };